<script lang="ts">
    import type {ToastMessage, ToastMessageTypeSettings, ToastType} from 'shared/components/kp-toast-messages/types';
    import KpLoadingImg from 'shared/components/kp-loading/KpLoadingImg.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import {getInjector} from 'core/svelte-context/context';
    import {ToastMessageService} from 'shared/components/kp-toast-messages/toast-message.service';

    export let toast: ToastMessage;

    const toastMessageService = getInjector().getByClass(ToastMessageService);
    const toastSettings: Record<ToastType, ToastMessageTypeSettings> = {
        'info': {
            icon: 'info',
            backgroundColor: 'var(--body-bg)',
            borderColor: 'var(--border-default)',
            textColor: 'var(--text-default)'
        },
        'success': {
            icon: 'check-circle',
            backgroundColor: 'var(--success-green)'
        },
        'error': {
            icon: 'cross-circle',
            backgroundColor: 'var(--danger-red)'
        },
        'warning': {
            icon: 'triangle-warning',
            backgroundColor: 'var(--warning-orange)'
        },
        'wait': {
            backgroundColor: 'var(--info-blue)'
        }
    }

    const settings = toastSettings[toast.type];

    const handleToastMessageDismiss = () => {
        toastMessageService.dismissToast(toast);
    }
</script>

<button class="toast-message-card"
        tabindex="-1"
        style:--bg-color="{settings.backgroundColor}"
        style:--text-color="{settings.textColor ?? 'white'}"
        style:--border-color="{settings.borderColor ?? 'rgba(0, 0, 0, 0.2)'}"
        on:click={handleToastMessageDismiss}>

    <span class="icon-container">
        {#if toast.type === 'wait'}
            <KpLoadingImg size="xs" color="white"/>
        {:else}
            <UIcon icon="{settings.icon ?? 'question'}"/>
        {/if}
    </span>

    <span class="texts-container">
        {#if toast.title}
            <span class="toast-title">{toast.title}</span>
        {/if}

        <span class="toast-message">{toast.message}</span>
    </span>
</button>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    .toast-message-card {
        padding: @spacing-m @spacing-ml;
        border-radius: @border-radius-default;
        display: flex;
        width: 100%;
        align-items: center;
        gap: @spacing-m;
        margin-bottom: @spacing-m;
        outline: none;
        cursor: pointer;
        background-color: var(--bg-color);
        border: 1px solid var(--border-color);
        color: var(--text-color);

        @media only screen and (max-width: @screen-xs-max) {
            padding: @spacing-s @spacing-m;
            margin-bottom: @spacing-s;

            .icon-container {
                font-size: @font-size-default;
            }

            .texts-container {
                font-size: @font-size-small;
            }
        }

        .icon-container {
            font-size: @font-size-large;
        }

        .texts-container {
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: start;
            justify-content: start;
            text-align: start;
            word-break: break-word;

            .toast-title {
                font-weight: 500;
            }
        }
    }
</style>